import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { NavLink, Link } from "react-router-dom";

import adminAction from "../../redux/admin/action";
import employeeAction from "../../redux/employee/action";

import logo from "../../assets/images/logoWhite.png";
import miniLogo from "../../assets/images/logoIcon.png";
import { useDispatch } from "react-redux";

function Sidebar({ setIsAdmin, authType, setAuthType }) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { setAdmin } = adminAction;
  const { setEmployee } = employeeAction;

  const logout = () => {
    dispatch(setAdmin({}));
    dispatch(setEmployee({}));
    setIsAdmin(false);
    setAuthType("");
    localStorage.removeItem("admintoken");
    localStorage.removeItem("emptoken");

    navigate("/");
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      {/* Sidebar */}
      <ul
        className="navbar-nav shadow sidebar sidebar-dark accordion zi-1 pb-100"
        id="accordionSidebar"
      >
        {/* Sidebar - Brand */}
        <Link
          className="sidebar-brand d-flex align-items-center justify-content-center mt-2"
          to="/"
        >
          <div className="sidebar-brand-text mx-3">
            <img src={logo} className="w-100" alt="waqazaka.net" />
          </div>
          <div className="mini">
            <img src={miniLogo} className="w-100" alt="waqazaka.net" />
          </div>
        </Link>
        {authType == "admin" && (
          <>
            <li className="nav-item my-2 mt-4">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/dashboard"
                end
              >
                <i className="fa-solid fa-house"></i>
                <span className="">Dashboard</span>
              </NavLink>
            </li>
            <li className="nav-item my-2 ">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/employees"
              >
                <i className="fa-solid fa-users"></i>
                <span className="">Employees</span>
              </NavLink>
            </li>
            {/* <li className="nav-item my-2 ">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/attendance"
              >
                <i className="fa-solid fa-users"></i>
                <span className="">Attendance</span>
              </NavLink>
            </li> */}
            <li className="nav-item my-2 ">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/tasks"
              >
                <i className="fa-solid fa-user"></i>
                <span className="">Tasks</span>
              </NavLink>
            </li>
            <li className="nav-item my-2 ">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/leaves"
              >
                <i className="fa-solid fa-user"></i>
                <span className="">Time Off</span>
              </NavLink>
            </li>
            <li className="nav-item my-2 ">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/notifications"
              >
                <i className="fa-solid fa-bell"></i>
                <span className="">Notifications</span>
              </NavLink>
            </li>
            <li className="nav-item my-2 ">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/admin/contact"
              >
                <i className="fa-solid fa-address-book"></i>
                <span className="">Contact</span>
              </NavLink>
            </li>
          </>
        )}
        {authType == "employee" && (
          <>
            <li className="nav-item my-2 ">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/employee/tasks"
              >
                <i className="fa-solid fa-list-check"></i>
                <span className="">Tasks</span>
              </NavLink>
            </li>
            {/* <li className="nav-item my-2 ">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/employee/attendance"
              >
                <i className="fa-solid fa-user"></i>
                <span className="">Attendance</span>
              </NavLink>
            </li> */}
            <li className="nav-item my-2 ">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/employee/leaves"
              >
                <i className="fa-solid fa-user"></i>
                <span className="">Time Off</span>
              </NavLink>
            </li>
            <li className="nav-item my-2 ">
              <NavLink
                className="nav-link sidebar-Link fw-500"
                to="/employee/profile"
              >
                <i className="fa-solid fa-user"></i>
                <span className="">Profile</span>
              </NavLink>
            </li>
          </>
        )}

        <li className="nav-item my-2 ">
          <div className="nav-link sidebar-Link fw-500" onClick={logout}>
            <i className="fa-solid fa-arrow-right-from-bracket"></i>
            <span className="">Logout</span>
          </div>
        </li>

        {/* Nav Item - Pages Collapse Menu */}
        {/* <li className="nav-item">
              <a className="nav-link collapsed" href="#" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                <i className="fas fa-fw fa-cog" />
                <span>Components</span>
              </a>
              <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordionSidebar">
                <div className="bg-white py-2 collapse-inner rounded">
                  <h6 className="collapse-header">Custom Components:</h6>
                  <a className="collapse-item" href="buttons.html">Buttons</a>
                  <a className="collapse-item" href="cards.html">Cards</a>
                </div>
              </div>
            </li> */}
      </ul>
      {/* End of Sidebar */}
    </>
  );
}
export default Sidebar;
